import React from 'react';
import {Box, BoxProps} from '@mui/material';

export interface TabPanelProps extends BoxProps {
  children: React.ReactNode;
  value: number | string;
  index: number | string;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <Box
      p={1}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export function tabPanelAriaProps(index: number | string) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default TabPanel;
